
const Modal = ({ active, setActive, text }) => {

	// блокируем скролл по странице когда открыт попап
	if (active) document.body.style.overflow = 'hidden';
	else document.body.style.overflow = 'auto';

	// при открытом попапе добавляем отступ справа, для исключения скачака. Когда попап закрываем - отступ убираем.
	const offModalClickHandler = () => {
		setActive(false);
		document.body.style.paddingRight = '0';
	}

	return (
		<div className={active ? "popup _active" : "popup"} onClick={offModalClickHandler}>
			<div className={active ? "popup__body _active" : "popup__body"} onClick={e => e.stopPropagation()}>
				{active && <div className="popup__text">{text}</div>}
			</div>
			<div className="popup__icon" onClick={offModalClickHandler}>
				<img src="assets/images/icons/icon-close.svg" alt="" />
			</div>
		</div>
	)
}

export default Modal;